/** onboarding — EN source (29 keys). */
export const onboarding = {
  onboarding_name_title: "What's your name?",
  onboarding_name_description: "This is how you'll appear to others on Linqx.",
  onboarding_birthdate_title: "When's your birthday?",
  onboarding_birthdate_description:
    "Your age will be shown on your profile. You must be at least 18.",
  onboarding_gender_title: "What's your gender?",
  onboarding_gender_description: "This helps us find better matches for you.",
  onboarding_location_title: "Turn On Location",
  onboarding_location_description:
    "We use your location to find potential matches near you.",
  onboarding_location_button: "Turn On Location",
  onboarding_notifications_title: "Stay in the Loop",
  onboarding_notifications_description:
    "Get notified when you receive a match or message.",
  onboarding_notifications_button: "Yes, notify me",
  onboarding_interests_title: "Interests",
  onboarding_interests_description:
    "Let everyone know what you're interested in by adding it to your profile.",
  onboarding_photos_title: "Upload your photos",
  onboarding_photos_description:
    "Attractive photos will increase the chance of finding new friends.",
  onboarding_photos_description_sub: "Add at least 2 photos to continue",
  onboarding_photos_main_badge: "Main",
  onboarding_photos_main_hint: "Your first photo is your main profile picture.",
  onboarding_photos_main_required_title: "Add a main photo",
  onboarding_photos_main_required:
    "Please add your main photo (the first slot) before leaving this step.",
  onboarding_rules_description: "House Rules",
  onboarding_rules_button: "Get started",
  onboarding_rule_1_title: "Be yourself.",
  onboarding_rule_1_description:
    "Make sure your photos, age, and bio are true to who you are.",
  onboarding_rule_2_title: "Stay safe.",
  onboarding_rule_2_description:
    "Don't be too quick to give out personal information.",
  onboarding_rule_3_title: "Play it cool.",
  onboarding_rule_3_description:
    "Respect others and treat them as you would like to be treated.",
  onboarding_rule_4_title: "Be proactive.",
  onboarding_rule_4_description: "Always report bad behavior.",
};
